// extracted by mini-css-extract-plugin
module.exports = {"footNotes":"FootNotes_footNotes__MMGk8","text":"FootNotes_text__S9HOQ"};